<template>
  <div class="detail-box">
    <el-button
      class="detail-btn"
      size="mini"
      type="primary"
      @click="handleBack">返回上一页</el-button>
    <span class="title">{{title}}</span>
    <span v-if="time" class="time">更新日期：{{time}}</span>

    <div v-if="newFileUrl.indexOf('.pdf') > -1" class="iframe-box">
      <span class="black pdfHideBack"></span>
      <iframe v-if="newFileUrl" class="file-iframe" :src="newFileUrl" frameborder="0"></iframe>
    </div>
    <!--<div class="content" v-html="htmlData">-->
    <!--</div>-->
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: [String, Number],
    fileUrl: String
  },
  data () {
    return {
      // title: '',
      time: '',
      newFileUrl: ''
      // htmlData: '', // 富文本内容
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.fileUrl) this.newFileUrl = this.$baseUrl + this.fileUrl
    },
    handleBack () {
      this.$emit('onDetailBack')
    }
  }
}
</script>

<style scoped lang="less">
  .iframe-box{
    width: 100%;
    position: relative;

    .black{
      position: absolute;
      top: 0px;
      right: 0px;
      width: 380px;
      height: calc(3.5vh + 25px);
      z-index: 10;
      background-color: #323639;
      user-select: none;
    }
  }
.file-iframe{
  width: 100%;
  height: 800px;
}
  .detail-box{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 20px;
    position: relative;

    .detail-btn{
      position: absolute;
      top: -2px;
      background-color: #006ED1;
      border-color: #006ED1;
    }

    .title{
      font-family: PingFang;
      font-weight: bold;
      font-size: 20px;
      color: #0067D1;
      line-height: 26px;
      width: 100%;
      text-align: center;
      margin-bottom: 28px;
    }

    .time{
      text-align: center;
      width: 100%;
      color: #999;
      font-size: 18px;
      margin-top: 0px;
      margin-bottom: 66px;
    }

    .content{
      width: 100%;
      overflow-x: auto;
      word-break: break-word;
    }
  }
</style>
